import React from 'react';

function DeviceStickerButton({ name, image, isActive, onSelect }: any) {
    return (
        <button
            type='button'
            onClick={onSelect}
            className={`flex h-[144px] flex-col items-center rounded-[30px] border border-[#DFE1E6] p-2 transition focus:outline-none focus:ring-2 focus:ring-blue-100 ${
                isActive ? 'bg-[#3F8EE8] text-white' : 'bg-white text-slate-700'
            }`}
        >
            <img src={image} alt={name} width={116} height={67} className='mb-2 h-[67px] w-[116px] object-contain' />
            <span className={`text-base font-semibold ${isActive ? 'text-white' : 'text-slate-700'}`}>{name}</span>
        </button>
    );
}

export default DeviceStickerButton;
